import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'columnName',
  standalone: true,
})
export class ColumnNamePipe implements PipeTransform {
  private columnMappings: { [key: string]: string } = {
    year: 'Year',
    month: 'Month',
    totalImageCount: 'Image Count',
    totalAnalysisCount: 'Analysis Count',
    customerCode: 'Customer Code',
    analysisCount: 'Analysis Count',
    imageCount: 'Image Count',
    monthlyPatientCount: 'Monthly Patient Count',
    totalPatientCount: 'Patient Count',
    doctorNameSurname: 'Doctor ',
  };

  transform(value: string): string {
    return this.columnMappings[value] || value;
  }
}
